
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows/veka/[slug]",
      function () {
        return require("private-next-pages/pvc/windows/veka/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows/veka/[slug]"])
      });
    }
  